import AxiosProvider from '@/app/utils/api/axios-provider';
import { postSseRequest, readSseStream } from '@/app/utils/api/sse-stream';
import { AxiosResponse } from 'axios';
import { ClientRequest } from './client-request.interface';

export interface PaginationParams {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export interface ClientDeletionProgressEvent {
  step: string;
  current: number;
  total: number;
  message: string;
}

export default {
  getClients(params?: PaginationParams): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get('/clients', { params });
  },
  getClientById(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get(`/clients/${id}`);
  },
  deleteClient(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.delete(`/clients/${id}`);
  },
  /**
   * Stream the progress of a client deletion via Server-Sent Events.
   * Resolves once the server emits its `complete` event; rejects if the
   * server emits an `error` event or the request itself fails.
   */
  async streamDeleteClient(
    id: number | string,
    onProgress?: (_event: ClientDeletionProgressEvent) => void
  ): Promise<void> {
    const baseURL = (config.VUE_APP_ATB_ADMIN_SERVICE_URL || '').replace(
      /[\\/]+$/,
      ''
    );
    const url = `${baseURL}/clients/${id}/delete/stream`;

    const response = await postSseRequest(url, undefined, 'Client deletion failed');
    await readSseStream<ClientDeletionProgressEvent>(
      response,
      onProgress,
      'Client deletion failed'
    );
  },
  addClient(client: ClientRequest): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.post('/clients', client);
  },
  updateClient(
    id: number | string,
    client: ClientRequest
  ): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.patch(`/clients/${id}`, client);
  },
};
